import {Timeline, TweenLite, TimelineLite} from "gsap";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenGameModuleConfig} from "../TombOfAkhenatenGameModuleConfig";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class BigWinStep implements GameRoundPresentation {

    stagger?: number;
    abortStagger?: number;
    private _isFirstStep: boolean;
    private _fromRatioConfig: IWinRatioConfig;
    private _toRatioConfig: IWinRatioConfig;
    private _hasWin: boolean;
    private _countFrom: number;
    private _countTo: number;
    private _lastLevel: boolean;
    private _lastLevelCount: number;
    private _lastLevelRemainderRatio: number;
    private _delay: number = 2.5; //#275
    private _isFirstStepStarted: boolean = false;


    constructor(fromRatioConfig: IWinRatioConfig, toRatioConfig: IWinRatioConfig, isFirstStep: boolean = false, stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
        this._fromRatioConfig = fromRatioConfig;
        this._toRatioConfig = toRatioConfig;
        this._isFirstStep = isFirstStep;
    }

    public prepare(data: TombOfAkhenatenParsedGameData): void {
        this._hasWin = false;
        this._countFrom = 0;
        this._countTo = 0;
        this._lastLevel = false;
        this._lastLevelCount = 0;
        this._lastLevelRemainderRatio = 0;
        this._isFirstStepStarted = false;

        if (data instanceof ParsedGameData) {
            if (data.singleWin <= 0) {
                return;
            }

            const currentWinRatio = data.singleWin / data.playedBetValue;
            this._hasWin = currentWinRatio >= this._toRatioConfig.ratio;
            this._countFrom = data.playedBetValue * this._fromRatioConfig.ratio;
            this._countTo = data.playedBetValue * this._toRatioConfig.ratio;
            if (data.currentWinRatioConfig && data.currentWinRatioConfig == this._toRatioConfig) {
                this._lastLevel = true;
                this._lastLevelCount = data.singleWin;
                const remainder: number = this._lastLevelCount - this._countTo;
                this._lastLevelRemainderRatio = remainder / data.playedBetValue;

                this._countTo = this._lastLevelCount;
            }
        }
    }

    public getAnimation(data: TombOfAkhenatenParsedGameData): Timeline | null {
        if (!this._hasWin || this.isLevelWinSmall(data)) {
            return null;
        }
        let totalWinWaysWon: number = 0;
        for (let i: number = 0; i < data.betWins.length; i++) {
            const betWayWinData: IBetWayWinData = <IBetWayWinData>data.betWins[i];

            totalWinWaysWon = totalWinWaysWon + betWayWinData.numberOfCombinations;
        }

        const tl: TimelineLite = new TimelineLite();

        const winTextStart: Timeline = TombOfAkhenatenGameModuleConfig.toaBigWinView.getStartAnimation(this._toRatioConfig);
        const count: Timeline = TombOfAkhenatenGameModuleConfig.toaCountupView.getWinStepAnimation(this._countFrom, this._countTo, this._toRatioConfig.duration, totalWinWaysWon);

        //todo initial win presentation and sounds
        /*if(this._isFirstStep) {
            const initTl:TimelineLite | null = TombOfAkhenatenGameModuleConfig.saInitialWinPresentation.getAnimation(data);

            tl.add([initTl,
                () => SlotGame.sound.playEffect(TombOfAkhenatenSoundConfig.instance.BIG_WIN),
            ], 0);
        }

        tl.add([
            () => SlotGame.sound.playEffect(TombOfAkhenatenSoundConfig.instance.BIG_WIN_LEVEL),
            winTextStart,
            count
        ], this._isFirstStep ? tl.totalDuration() - 1 : 0);*/
        tl.add(TweenLite.to({}, this._delay, {})); //258
        tl.add([
            () => {
                if (this._isFirstStep) {
                    this._isFirstStepStarted = true;
                }
            },
            winTextStart,
            count
            //], this._isFirstStep ? 0 : 0);
        ], this._isFirstStep ? tl.totalDuration() - 1 : 0); //258

        return tl;
    }

    public abort(isActive: boolean, data: TombOfAkhenatenParsedGameData): Timeline | null {
        if (!this._hasWin) {
            return null;
        }

        if (this._isFirstStep && !this._isFirstStepStarted) {
            TombOfAkhenatenGameModuleConfig.toaBigWinView.playBigWinAnimation(this._toRatioConfig, false)
        }

        const tl: TimelineLite = new TimelineLite();
        const winText = TombOfAkhenatenGameModuleConfig.toaBigWinView.abort(this._toRatioConfig);

        let count;
        if (this._lastLevel) {
            count = TombOfAkhenatenGameModuleConfig.toaCountupView.abort(this._lastLevelCount);
        } else {
            count = TombOfAkhenatenGameModuleConfig.toaCountupView.abort(this._countTo);
        }

        tl.add([
            winText,
            count
        ]);

        return tl;
    }

    private isLevelWinSmall(data: TombOfAkhenatenParsedGameData): boolean {
        if (this._toRatioConfig.ratio === 15) {
            return false;
        }
        var fromValue = data.playedBetValue * this._toRatioConfig.ratio;
        var toValue = data.totalWin;
        return (toValue - fromValue) <= (fromValue * 0.1);
    }

    private playSound(config: IWinRatioConfig) {
        // SlotGame.sound.playEffect(config.sound!);
    }
}